import { render, staticRenderFns } from "./IbProgressDashboard.vue?vue&type=template&id=3e442eb0&scoped=true"
import script from "./IbProgressDashboard.vue?vue&type=script&lang=js"
export * from "./IbProgressDashboard.vue?vue&type=script&lang=js"
import style0 from "./IbProgressDashboard.vue?vue&type=style&index=0&id=3e442eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e442eb0",
  null
  
)

export default component.exports